import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    // redirect: '/website',
    component: () => import('../views/website/index.vue'),
  },
  {
    path: '/trip',
    component: () => import('../views/H5/trip.vue'),
  },
  {
    path: '/note',
    component: () => import('../views/H5/note.vue'),
  },{
    path: '/userService',
    component: () => import('../views/H5/userService.vue'),
  },{
    path: '/privacy',
    component: () => import('../views/H5/privacy.vue'),
  },{
    path: '/logoff',
    component: () => import('../views/H5/logoff.vue'),
  },{
    path: '/website',
    component: () => import('../views/website/index.vue'),
  },{
    path: '/trip/share/:id',
    component: () => import('../views/H5/download.vue'),
  },{
    path: '/trip/invite/:id',
    component: () => import('../views/H5/download.vue'),
  },{
    path: '/note/:id',
    component: () => import('../views/H5/download.vue'),
  }

]
const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_publicPath,
  scrollBehavior: () => ({ y: 0 }),
  routes //默认引入静态路由
})
const router = createRouter()
export default router
